import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M11 15c-.1 0-.3 0-.4-.1l-2-2c-.2-.2-.2-.5 0-.7s.5-.2.7 0l1.6 1.6 4.6-4.6c.2-.2.5-.2.7 0s.2.5 0 .7l-5 5c.1.1-.1.1-.2.1zm1-11.7l-1.6 1.3-.3.3-.5-.2-2-.3-.7 1.9-.2.4-.4.2-1.9.7.3 2 .1.4-.3.3L3.3 12l1.3 1.6.3.3-.1.4-.3 2 1.9.7.4.2.2.4.7 1.9 2-.3.4-.1.3.3 1.6 1.3 1.6-1.3.3-.3.4.1 2 .3.7-1.9.2-.4.4-.2 1.9-.7-.3-2-.1-.4.3-.3 1.3-1.6-1.3-1.6-.3-.3.1-.4.3-2-1.9-.7-.4-.2-.2-.4-.7-1.9-2 .3-.4.1-.3-.3L12 3.3M12 2l2.2 1.8 2.8-.5L18 6l2.6 1-.4 2.8L22 12l-1.8 2.2.4 2.8-2.6 1-1 2.6-2.8-.4L12 22l-2.2-1.8-2.8.5L6 18l-2.6-1 .4-2.8L2 12l1.8-2.2L3.3 7 6 6l1-2.6 2.8.4L12 2z',
  ],
  height: 24,
  width: 24,
});
